import { useState, useEffect } from 'react';
import api from '../services/api';

// Simple in-memory cache so we only fetch the map once per page load.
let cachedMap = null;
let inflight = null;

/**
 * useSiteImages()
 *   returns { get(key, fallback), ready, refresh }
 *
 * Pages call `siteImages.get('home.hero.main', defaultUrl)` — before the
 * fetch completes we transparently fall back to the passed default so
 * nothing ever renders empty.
 */
export function useSiteImages() {
  const [map, setMap] = useState(cachedMap || {});
  const [ready, setReady] = useState(!!cachedMap);

  useEffect(() => {
    if (cachedMap) return;
    if (!inflight) {
      inflight = api
        .request('/site-images')
        .then((data) => {
          cachedMap = data || {};
          return cachedMap;
        })
        .catch(() => {
          cachedMap = {};
          return cachedMap;
        });
    }
    inflight.then((data) => {
      setMap(data);
      setReady(true);
    });
  }, []);

  return {
    ready,
    get: (key, fallback = '') => (map && map[key]) || fallback,
    refresh: async () => {
      cachedMap = null;
      inflight = null;
      const data = await api.request('/site-images');
      cachedMap = data || {};
      setMap(cachedMap);
      return cachedMap;
    },
  };
}
